import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer'

const useCurrentUserId = () : string | undefined => {
  const userDb = useSelector((state: RootState) => state.userDb)
  if (userDb.currentUserId) {
    const userId = userDb.currentUserId
    return userId
  } else {
    return undefined
  }
}

export default useCurrentUserId
